// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import {
    wareHouseDataReducer,
    createWareHouseDataReducer,
    updateWarehouseDataReducer,
    deleteWarehouseDataReducer,
    uploadWareHouseDataReducer,
} from './wareHouse/reducers';
import {
    inboundReducer, getEditInboundReducer, createInboundReducer,
    uploadInboundReducer, updateInboundReducer, updateAllReducer,
    updateAllYardsReducer, updateSelectedReducer, deleteInboundReducer,
    tagReducer, tagDataReducer, updateSelectedUnitReducer,
    updateInventoryTransactionReducer, getByTagReducer,
    getByDocReducer, getPrintContentReducer, getExcelContentReducer,
    updateTagByStatusReducer, updateAllSellingPriceReducer, updateSelectedDescriptionReducer,
    updateAllDescriptionReducer, getInvoiceDataReducer, getReceiverDataReducer, updateAllUnitsReducer
} from './InboundOutbound/reducers';
import {
    vendorDataReducer,
    createVendorDataReducer,
    updateVendorDataReducer,
    deleteVendorDataReducer,
    accountDataReducer,
    createAccountDataReducer,
    updateAccountDataReducer,
    deleteAccountDataReducer,
    uploadAccountDataReducer,
    uploadClientDataReducer,
} from './client/reducers';
import {
    commodityDataReducer,
    createCommodityDataReducer,
    updateCommodityDataReducer,
    deleteCommodityDataReducer,
    uploadCommodityDataReducer,
} from './commodity/reducers';
import {
    commodityCategoryDataReducer,
    createCommodityCategoryDataReducer,
    updateCommodityCategoryDataReducer,
    deleteCommodityCategoryDataReducer,
} from './commodityCategory/reducers';
import { unitDataReducer, createUnitDataReducer, updateUnitDataReducer, deleteUnitDataReducer, uploadUnitDataReducer } from './unit/reducers';
import { InventoryDataReducer, updateInventoryReducer, ProfitLossDataReducer } from './inventory/reducers';
import { DashboardDataReducer } from './Dashboard/reducers';
import { createSupportReducer, supportReducer, supportAdminReducer, updateSupportReducer, createChatReducer, getChatReducer, getTicketByIdReducer } from './Help&Support/reducers';
import { companyDataReducer, companyDetailsDataReducer, createCompanyDataReducer, updateCompanyDataReducer, deleteCompanyDataReducer } from './company/reducers';
import { stockDataReducer, createStockDataReducer, updateStockDataReducer, deleteStockDataReducer, uploadStockDataReducer, getTagInStockDataReducer } from './stock/reducers';
import { transactionHistoryReducer,deletedTransactionHistoryReducer } from './TransactionHistory/reducers';
import { userDataReducer, createUserDataReducer, updateUserDataReducer, deleteUserDataReducer } from './users/reducers';
import { transactionCsvReducer, accountCsvReducer, traderCsvReducer, userCsvReducer, commodityCsvReducer } from './downloadCSV/reducers';
import { tagSearchDataReducer } from './tagSearch/reducers';
import Reports from './reports/reducers';
export default (combineReducers({
    Auth,
    Layout,
    wareHouseDataReducer,
    createWareHouseDataReducer,
    updateWarehouseDataReducer,
    deleteWarehouseDataReducer,
    uploadWareHouseDataReducer,
    inboundReducer, getEditInboundReducer,
    createInboundReducer,
    uploadInboundReducer,
    updateInboundReducer,
    deleteInboundReducer,
    vendorDataReducer,
    createVendorDataReducer,
    updateVendorDataReducer,
    deleteVendorDataReducer,
    commodityDataReducer,
    createCommodityDataReducer,
    updateCommodityDataReducer,
    deleteCommodityDataReducer,
    uploadCommodityDataReducer,
    commodityCategoryDataReducer,
    createCommodityCategoryDataReducer,
    updateCommodityCategoryDataReducer,
    deleteCommodityCategoryDataReducer,
    unitDataReducer,
    createUnitDataReducer,
    updateUnitDataReducer,
    deleteUnitDataReducer,
    uploadUnitDataReducer,
    tagReducer,
    tagDataReducer,
    ProfitLossDataReducer,
    InventoryDataReducer,
    updateInventoryReducer,
    DashboardDataReducer,
    updateAllReducer,
    updateAllYardsReducer,
    updateSelectedReducer,
    accountDataReducer,
    createAccountDataReducer,
    updateAccountDataReducer,
    deleteAccountDataReducer,
    uploadAccountDataReducer,
    uploadClientDataReducer,
    updateSelectedUnitReducer,
    updateInventoryTransactionReducer,
    getByTagReducer,
    getByDocReducer,
    getPrintContentReducer, getExcelContentReducer, updateTagByStatusReducer, updateAllSellingPriceReducer, updateSelectedDescriptionReducer, updateAllDescriptionReducer,
    createSupportReducer,
    supportReducer,
    supportAdminReducer,
    updateSupportReducer,
    createChatReducer,
    getChatReducer, getTicketByIdReducer,
    companyDataReducer, companyDetailsDataReducer, createCompanyDataReducer, updateCompanyDataReducer, deleteCompanyDataReducer,
    stockDataReducer, createStockDataReducer, updateStockDataReducer, deleteStockDataReducer, uploadStockDataReducer, getTagInStockDataReducer,
    transactionHistoryReducer,deletedTransactionHistoryReducer,
    userDataReducer, createUserDataReducer, updateUserDataReducer, deleteUserDataReducer,
    getInvoiceDataReducer, getReceiverDataReducer, updateAllUnitsReducer,
    transactionCsvReducer, accountCsvReducer, traderCsvReducer, userCsvReducer, commodityCsvReducer,
    tagSearchDataReducer,
    Reports
}): any);
